
$(".c-overlaySearch-openButton").add(".c-overlaySearch-close").on("click", function(){

  if(!($("body").hasClass("is-searchContent--showPage"))) {
    $(".c-overlaySearch").addClass("is-searchContent--show");
    $("body").removeClass('is-searchContent--hidePage').addClass('is-searchContent--showPage');
    // $("body").removeClass("is-close").addClass("is-open");

    // 現在のスクロール位置を取得
    $('html').data('scrTop', $(window).scrollTop());//メニューを開いた位置を保存
    $('body,html').css({"position":"fixed","top": -1 * $('html').data('scrTop'),"height":"100%"});

  } else {
    $('body,html').css({"position":"static","overflow":"visible","height":"auto"});
    setTimeout(function() {
      $(".c-overlaySearch").removeClass("is-searchContent--show");
      $("body").removeClass("is-searchContent--showPage");
    }, 100);
    // メニューを開いた時点のスクロール位置を反映
    $(window).scrollTop($('html').data('scrTop'));//メニューを開いた位置へ移動

  }
})


$('.c-overlaySearch__date').on('change', function(){
  var searchDate = $(this).val()
  var arrSearchDate = searchDate.split("/");

  $(".c-overlaySearch__item input[name='obj_year']").val( arrSearchDate[0] );
  $(".c-overlaySearch__item input[name='obj_month']").val( arrSearchDate[1] );
  $(".c-overlaySearch__item input[name='obj_day']").val( arrSearchDate[2] );
  // console.log(arrSearchDate)
})
